export const defaultIconProps = {
    strokeWidth: 1.5,
} as const

export const pageTransitionClassName = 'animate-in fade-in-0 transition-all duration-300' as const
